export default {
  ENV: 'prod',
  BASE_URL: 'https://api.mozio.com',
  BASE_URL_V2: 'https://api.mozio.com/v2',
  TRACKING_SERVICE_BASE_URL_V1: 'https://tracking-api.mozio.com/v1',
}
